import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { DfImageWrapperComponent } from '@df/module-image/df-image-wrapper.component';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentField } from '@icms/core/content';
import { defaultImagePng } from '../../../icms.config';
import { IconsOptions } from '../../../styles/cms.config';

export namespace NFirstMissionIntroduction {
    export const componentId = 'first-mission-introduction';

    export type IBlockData = Catalog.IBlockData<IFirstMissionIntroductionContent>;

    export interface IFirstMissionIntroductionContent {
        image: string;
        icon?: string;
        title: string;
        description: string;
        continueButtonText: string;
        skipButtonText: string;
        darkContrast: boolean;
        blur: boolean;
        overlayOpacity: number;
    }
}

@Component({
    selector: 'first-mission-introduction',
    templateUrl: './first-mission-introduction.component.html',
    styleUrls: ['./first-mission-introduction.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, ICmsClientModule, DfImageWrapperComponent, DfImageDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<FirstMissionIntroductionComponent>({
    id: NFirstMissionIntroduction.componentId,
    block: {
        url: NFirstMissionIntroduction.componentId
    },
    onDemandOnly: true,
    name: 'First Mission Introduction View',
    fields: [
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image',
            required: true,
            default: defaultImagePng
        },
        <NICmsContentField.IChoiceField>{
            key: 'icon',
            title: 'Icon',
            type: NICmsContentField.EFieldType.choice,
            options: IconsOptions,
            previewMode: 'icon',
            default: 'icon-mission'
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'title',
            title: 'Title',
            default: 'Let’s start your first Mission!',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'description',
            title: 'Description',
            default: 'Complete your profile to finish your first mission and win 50 Rosettes 🎉',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'continueButtonText',
            title: 'Continue Button Text',
            default: 'Let’s do it!',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'skipButtonText',
            title: 'Skip Button Text',
            default: 'Maybe Later',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'darkContrast',
            title: 'Dark Contrast',
            default: true
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'blur',
            title: 'Blur',
            default: false
        },
        <NICmsContentField.ISliderField>{
            type: NICmsContentField.EFieldType.slider,
            key: 'overlayOpacity',
            title: 'Overlay Opacity',
            default: 0.25,
            min: 0,
            max: 1,
            step: 0.05,
            required: true
        }
    ]
})
export class FirstMissionIntroductionComponent extends UiComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    protected content?: NFirstMissionIntroduction.IFirstMissionIntroductionContent;
}
